import React from 'react';
import Input from '@/components/ui/Input';
import {Link} from 'react-router-dom';
import {TeamSelectionPlayer} from './types';

interface PlayerChooserProps {
  activePositionId: string | null;
  query: string;
  onQueryChange: (value: string) => void;
  availablePlayersSorted: TeamSelectionPlayer[];
  onChoose: (p: TeamSelectionPlayer) => void;
  onAddToBench: (p: TeamSelectionPlayer) => void;
}

const PlayerChooser: React.FC<PlayerChooserProps> = ({
  activePositionId,
  query,
  onQueryChange,
  availablePlayersSorted,
  onChoose,
  onAddToBench,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-semibold text-gray-700 dark:text-gray-200">Assign Player</div>
        <div className="text-xs text-gray-500 dark:text-gray-400">{activePositionId ? `Position: ${activePositionId}` : 'Select a position'}</div>
      </div>
      <Input placeholder="Search player..." value={query} onChange={(e) => onQueryChange(e.target.value)} />
      <div className="mt-3 h-[600px] overflow-auto rounded border border-gray-200 dark:border-gray-800">
        {availablePlayersSorted.map((p) => (
          <div
            key={p.id}
            className="w-full border-b border-gray-100 px-3 py-2 last:border-b-0 dark:border-gray-800"
          >
            <Link className="text-sm font-medium text-gray-900 hover:underline dark:text-gray-100" to={`/players/${p.id}`} aria-label={`View ${p.name}`}>
              {p.name}
            </Link>
            <div className="text-xs text-gray-500">{p.position}{p.team ? ` • ${p.team}` : ''}</div>
            <div className="mt-1 flex gap-3">
              <button
                type="button"
                className="text-xs text-primary-600 hover:underline disabled:text-gray-400"
                disabled={!activePositionId}
                aria-label={`Assign ${p.name} to ${activePositionId || 'a position'}`}
                onClick={() => onChoose(p)}
              >
                Assign
              </button>
              <button
                type="button"
                className="text-xs text-primary-600 hover:underline"
                onClick={() => onAddToBench(p)}
              >
                Add to bench
              </button>
            </div>
          </div>
        ))}
        {availablePlayersSorted.length === 0 && (
          <div className="px-3 py-6 text-center text-sm text-gray-500">No players available</div>
        )}
      </div>
    </div>
  );
};

export default PlayerChooser;
